import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../css/Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useUser } from "../hooks/useUser";
import { useUserNames } from "../hooks/useUserNames";
import CoinIcon from "../components/CoinIcon";
import InboxComponent from "./InboxComponent";
import SearchSuggestions from "./SearchSuggestions";
import Logo from "../assets/Logo.png";
import SteamLoginButton from "./SteamLoginButton";

import { useMemo } from "react";

function Header() {
  const [sticky, setSticky] = useState(false);
  const { user, loading, error } = useUser();
  const { userNames } = useUserNames();
  const [coins, setCoins] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  // Handle user selection from search suggestions
  const handleUserSelect = (selectedUser) => {
    if (selectedUser && selectedUser.userNumber) {
      navigate(`/profile/${selectedUser.userNumber}`);
      setSearchTerm(""); // Clear search term after navigation
    }
  };

  // Calculate font size for username based on its length
  const getUsernameFontSize = (username) => {
    if (!username) return "1vw";
    if (username.length <= 8) return "1vw";

    return 1 - username.length * 0.03 + "vw";
  };

  useEffect(() => {
    setSearchTerm("");
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (user && user.bank) {
      setCoins(user.bank.coins);
    }
  }, [user]);

  useEffect(() => {
    const ws = new WebSocket(`wss://api.csultimatefantasy.com/ws`);

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.type === "UPDATE_COINS" && data.userID === user?._id) {
        setCoins(data.coins);
      }
    };

    return () => {
      ws.close();
    };
  }, [user]);

  const headerContent = useMemo(
    () => (
      <header
        className={`${sticky ? "sticky" : ""}`}
        style={{ height: "3vw", display: "flex" }}
      >
        <nav className="navbar col-10 offset-1">
          <div className="navbar-links">
            <div className="close col-auto">
              <a href="/" className="header-logo navbar-link">
                <img
                  src={Logo}
                  alt="Logo"
                  style={{ width: "100%", height: "100%" }}
                />
              </a>
            </div>
            <div className="col-auto close">
              <a
                className={`navbar-link ${
                  location.pathname === "/packs" && "header-current-tab"
                }`}
                href="/packs"
              >
                Packs
              </a>
            </div>
            <div className="col-auto close">
              <a
                className={`navbar-link ${
                  location.pathname === "/inventory" && "header-current-tab"
                }`}
                href="/inventory"
              >
                Inventory
              </a>
            </div>
            <div className="col-auto close">
              <a
                className={`navbar-link ${
                  location.pathname === "/market" && "header-current-tab"
                }`}
                href="/market"
              >
                Market
              </a>
            </div>
            <div className="col-auto close">
              <a
                className={`navbar-link ${
                  location.pathname === "/events" && "header-current-tab"
                }`}
                href="/events"
              >
                Events
              </a>
            </div>
            <div className="col-auto close">
              <a
                className={`navbar-link ${
                  location.pathname === "/tbc" && "header-current-tab"
                }`}
                href="/tbc"
              >
                TBC
              </a>
            </div>
            <div className="col-auto close">
              <a
                className={`navbar-link ${
                  location.pathname === "/clutch-picks" && "header-current-tab"
                }`}
                href="/clutch-picks"
              >
                Clutch Picks
              </a>
            </div>
            <div className="col-auto close">
              <a
                className={`navbar-link ${
                  location.pathname === "/leaderboard" && "header-current-tab"
                }`}
                href="/leaderboard"
              >
                Leaderboard
              </a>
            </div>
            <div className="col-auto close">
              <a
                className={`navbar-link ${
                  location.pathname === "/league" && "header-current-tab"
                }`}
                href="/league"
              >
                League
              </a>
            </div>
            <div className="col-auto close">
              <a
                className={`navbar-link ${
                  location.pathname === "/howtoplay" && "header-current-tab"
                }`}
                href="/howtoplay"
              >
                How to play
              </a>
            </div>
            <div className="header-search">
              <SearchSuggestions
                query={userNames || []}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                onSelect={handleUserSelect}
                placeholder="Search users..."
                suggestionsLength={10}
                zIndex={1000}
              />
            </div>
          </div>
          {loading ? (
            <div className="loader-small" />
          ) : user ? (
            <div className="navbar-user-info">
              <div>
                <InboxComponent userId={user?._id} />
              </div>
              <div>
                <p className="coin-info">
                  <CoinIcon width="0.9vw" height="0.9vw" />{" "}
                  {error ? "Error" : coins}
                </p>
              </div>
              <div>
                <a
                  className={`navbar-link ${
                    location.pathname === "/profile" && "header-current-tab"
                  }`}
                  href={`/profile/${user?.userNumber}`}
                  style={{ fontSize: getUsernameFontSize(user?.username) }}
                >
                  {loading ? (
                    <div className="loader-small" />
                  ) : error ? (
                    "Error"
                  ) : (
                    user?.username || "Profile"
                  )}
                </a>
              </div>
            </div>
          ) : (
            <div className="navbar-user-info" style={{ marginRight: "0.5vw" }}>
              <SteamLoginButton long={true} />
            </div>
          )}
        </nav>
      </header>
      // eslint-disable-next-line react-hooks/exhaustive-deps
    ),
    [
      sticky,
      user,
      loading,
      error,
      coins,
      location.pathname,
      userNames,
      searchTerm,
    ]
  );

  return headerContent;
}

export default Header;
